module.exports = __WEBPACK_EXTERNAL_MODULE_21__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom","root":"ReactDOM"}
 ** module id = 21
 ** module chunks = 0
 **/